import { cn } from '../lib/cn'

const statusStyles: Record<string, string> = {
  Backlog: 'bg-ink-100 text-ink-600',
  'To Do': 'bg-info-50 text-info-600',
  'In Progress': 'bg-warning-50 text-warning-600',
  Review: 'bg-brand-50 text-brand-600',
  Completed: 'bg-success-50 text-success-600',
  Done: 'bg-success-50 text-success-600',
  Active: 'bg-success-50 text-success-600',
  'On Hold': 'bg-ink-100 text-ink-600',
  Planning: 'bg-info-50 text-info-600',
  Onboarding: 'bg-info-50 text-info-600',
  'At Risk': 'bg-danger-50 text-danger-600',
  Paused: 'bg-ink-100 text-ink-500',
  'Not Started': 'bg-ink-100 text-ink-600',
  'In Review': 'bg-brand-50 text-brand-600',
  Pending: 'bg-warning-50 text-warning-600',
  Approved: 'bg-success-50 text-success-600',
  'Changes Requested': 'bg-danger-50 text-danger-600',
  Scheduled: 'bg-info-50 text-info-600',
  Posted: 'bg-success-50 text-success-600',
  'Not Scheduled': 'bg-ink-100 text-ink-500',
  Away: 'bg-warning-50 text-warning-600',
  Inactive: 'bg-ink-100 text-ink-400',
  Prospect: 'bg-info-50 text-info-600',
  Unconfirmed: 'bg-warning-50 text-warning-600',
  Former: 'bg-ink-100 text-ink-500',
  Lost: 'bg-ink-100 text-ink-400',
}

const dotStyles: Record<string, string> = {
  Backlog: 'bg-ink-400',
  'To Do': 'bg-info-500',
  'In Progress': 'bg-warning-500',
  Review: 'bg-brand-500',
  Completed: 'bg-success-500',
  Done: 'bg-success-500',
  Active: 'bg-success-500',
  'On Hold': 'bg-ink-400',
  Planning: 'bg-info-500',
  Onboarding: 'bg-info-500',
  'At Risk': 'bg-danger-500',
  Paused: 'bg-ink-400',
  'Not Started': 'bg-ink-400',
  'In Review': 'bg-brand-500',
  Pending: 'bg-warning-500',
  Approved: 'bg-success-500',
  'Changes Requested': 'bg-danger-500',
  Scheduled: 'bg-info-500',
  Posted: 'bg-success-500',
  'Not Scheduled': 'bg-ink-400',
  Away: 'bg-warning-500',
  Inactive: 'bg-ink-300',
  Prospect: 'bg-info-500',
  Unconfirmed: 'bg-warning-500',
  Former: 'bg-ink-400',
  Lost: 'bg-ink-300',
}

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap',
        statusStyles[status] ?? 'bg-ink-100 text-ink-600',
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', dotStyles[status] ?? 'bg-ink-400')} />
      {status}
    </span>
  )
}
